import { TargetingTypeAllocation } from './targeting-type-allocation';
import Base, { baseInit } from './base';

export class ProductTypeAllocation extends Base {
  id = null; // Integer
  productTypeId = null; // Integer
  budgetPercentage = null; // Integer
  budget = null; // Integer
  impressions = null; // Integer
  cpm = null; // Double
  maxCpm = null; // Double
  targetingTypeAllocations = null; // [TargetingTypeAllocations{}]

  constructor(data) {
    super(data);
    baseInit(this, data);
    if (this.targetingTypeAllocations === null) {
      this.targetingTypeAllocations = new TargetingTypeAllocation();
    }
  }
}
